import React, { useState } from "react";
import "./commonStyles.css";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

export const ComboBox = (props) => {
  const {
    id,
    label,
    isError,
    isRequired,
    isDisabled,
    selectedValue,
    list,
    onChange,
  } = props;
  const [selectedOption, setSelectedOption] = useState(selectedValue);

  const indexChangeHandler = (event, newValue) => {
    setSelectedOption(newValue);
    onChange(id, newValue);
  };

  return (
    <div>
      <label>
        {label}
        {isRequired && (
          <label
            style={{ color: "red", fontWeight: "bolder", fontSize: "18px" }}
          >
            *
          </label>
        )}
      </label>
      <Autocomplete
        disablePortal={isDisabled}
        required={isRequired}
        className={isError ? "inputLayoutError" : ""}
        id={id}
        value={selectedOption}
        options={list}
        onChange={indexChangeHandler}
        filterSelectedOptions
        size="small"
        sx={{
          width: "100%",
          p: 0,
        }}
        renderInput={(params) => <TextField sx={{ p: 0 }} {...params} />}
      />
    </div>
  );
};
